import React, { useState, useEffect } from 'react'
import { Modal, Spinner } from 'reactstrap'
import { FaTimes } from 'react-icons/fa'
import { useDispatch } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import useCategories from '../../hooks/useCategories'
import { assignMultipleProductsCategoryAction } from '../../../../redux/modules/product'

export default function ModalAssignProduct({ isOpen, toggle, selectedItems = [], onSuccess }) {
  const dispatch = useDispatch()
  const { addToast } = useToasts()
  const { categories } = useCategories()
  const [searchQuery, setSearchQuery] = useState('')
  const [selectedCategoryId, setSelectedCategoryId] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      setSearchQuery('')
      setSelectedCategoryId(null)
      setIsSubmitting(false)
    }
  }, [isOpen])

  const handleClose = () => {
    if (toggle) toggle()
  }

  const handleConfirm = async () => {
    if (!selectedCategoryId || selectedItems.length === 0 || isSubmitting) return

    try {
      setIsSubmitting(true)
      const productIds = selectedItems.map((item) => item.id)
      const selectedCategory = (categories || []).find((cat) => cat.id === selectedCategoryId)
      const categoryName = selectedCategory ? selectedCategory.name : null

      const response = await dispatch(
        assignMultipleProductsCategoryAction(productIds, selectedCategoryId, categoryName)
      )

      addToast(
        response?.msgResp?.message || 'Category assigned successfully',
        { appearance: 'success', autoDismiss: true }
      )

      if (onSuccess) {
        onSuccess()
      }
      handleClose()
    } catch (error) {
      addToast(
        error?.msgResp || error?.message || 'Failed to assign category',
        { appearance: 'error', autoDismiss: true }
      )
    } finally {
      setIsSubmitting(false)
    }
  }

  const filteredCategories = (categories || []).filter((cat) =>
    cat.name?.toLowerCase().includes(searchQuery.trim().toLowerCase()))

  return (
    <Modal isOpen={isOpen} toggle={toggle} className='modal-from-product' centered>
      <div className='modal-from-product__container'>
        {/* Header */}
        <div className='modal-from-product__header'>
          <h3 className='modal-from-product__title'>Assign Category</h3>
          <button type='button' className='modal-from-product__close-btn' onClick={handleClose}>
            <FaTimes />
          </button>
        </div>

        {/* Search */}
        <div className='modal-from-product__search-wrapper'>
          <i className='modal-from-product__search-icon icon-search'></i>
          <input
            type='text'
            className='modal-from-product__search-input'
            placeholder='Search categories...'
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* List of Categories */}
        <div id='scrollableDivAssignCategory' className='modal-from-product__list'>
          {filteredCategories.length === 0 ? (
            <div className='modal-from-product__empty'>No categories found</div>
          ) : (
            filteredCategories.map((category) => {
              const isSelected = selectedCategoryId === category.id
              return (
                <div
                  key={category.id}
                  className={`modal-from-product__item ${isSelected ? 'selected' : ''}`}
                  onClick={() => setSelectedCategoryId(category.id)}
                >
                  <div className='modal-from-product__top-row'>
                    <div className='modal-from-product__info' style={{ paddingLeft: 0 }}>
                      <h4 className='modal-from-product__item-name'>{category.name}</h4>
                      {category.type && (
                        <p className='modal-from-product__item-desc'>Type: {category.type}</p>
                      )}
                    </div>
                    <div className='modal-from-product__price-box'>
                      <div className={`modal-from-product__checkbox ${isSelected ? 'checked' : ''}`}>
                        {isSelected && <div className='modal-from-product__checkbox-checked' />}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
          )}
        </div>

        {/* Footer */}
        <div className='modal-from-product__footer' style={{ justifyContent: 'flex-end' }}>
          <div className='modal-from-product__actions'>
            <button
              type='button'
              className='modal-from-product__btn-cancel'
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type='button'
              className='modal-from-product__btn-submit'
              disabled={!selectedCategoryId || isSubmitting}
              onClick={handleConfirm}
            >
              {isSubmitting ? <Spinner size='sm' /> : 'Confirm'}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
